import { LockScroll } from '../helpers/helpers';

const SEARCH_ELEMENT = {
    search: 'm-search',
    openButton: '.js-open-search',
    closeButton: '.js-close-search',
    showClass: 'is-show',
    wrapper: '.js-search-layout'
};

const state = {
    search: null,
    wrapper: null,
};

/**
 * закроет поиск
 */
function closeSearch() {
    state.search.classList.remove(SEARCH_ELEMENT.showClass);
    // eslint-disable-next-line no-use-before-define
    document.removeEventListener('click', handlerClick);
    // eslint-disable-next-line no-use-before-define
    document.removeEventListener('keyup', handlerKeyUp);
    LockScroll.unLock();
}

/**
 * обработка клика внеобласти поиска
 * @param e {Event}
 */
function handlerClick(e) {
    const isClickInside = state.wrapper.contains(e.target);

    if (!isClickInside) {
        closeSearch();
    }
}

/**
 * закроет поиск по Esc
 * @param event {Event}
 */
function handlerKeyUp(event) {
    if (event.code === 'Escape' || event.keyCode === 27) {
        closeSearch();
    }
}

/**
 * откроет поиск
 */
function openSearch() {
    state.search.classList.add(SEARCH_ELEMENT.showClass);

    setTimeout(() => {
        document.addEventListener('click', handlerClick);
        document.addEventListener('keyup', handlerKeyUp);
    }, 100);

    LockScroll.lock();
}

export default function toggleSearch() {
    state.search = document.getElementById(SEARCH_ELEMENT.search);
    state.wrapper = state.search.querySelector(SEARCH_ELEMENT.wrapper);
    const openButton = document.querySelector(SEARCH_ELEMENT.openButton);
    const closeButton = document.querySelector(SEARCH_ELEMENT.closeButton);

    openButton.addEventListener('click', openSearch);
    closeButton.addEventListener('click', closeSearch);
}
